import { useShouldShowQuantifyCooccurringToggle } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { useCallback, useRef } from 'react';
import { EQLFunction, EQLFunctionName } from 'v2/core/repository/eql/types';
import { shallow } from 'zustand/shallow';

export function useAddApplyTaxonomyFunctionIfRequired() {
  const shouldShowQuantifyCooccurringToggle =
    useShouldShowQuantifyCooccurringToggle();
  const state = useQuantifyStore(({ query, metadata }) => {
    return {
      compareTo: query.compareTo,
      shouldShowCooccurringDataPoints: metadata.shouldShowCooccurringDataPoints,
    };
  }, shallow);

  const dependencies = {
    ...state,
    shouldShowQuantifyCooccurringToggle,
  };
  const dependenciesRef = useRef(dependencies);
  dependenciesRef.current = dependencies;

  return useCallback((functions: EQLFunction[]) => {
    if (dependenciesRef.current.compareTo?.type !== 'whereClause') {
      functions.push({
        name: EQLFunctionName.ApplyTaxonomy,
        params:
          dependenciesRef.current.shouldShowQuantifyCooccurringToggle &&
          dependenciesRef.current.shouldShowCooccurringDataPoints
            ? ['include-irrelevant']
            : undefined,
      });
    }
  }, []);
}
